import { RJSFSchema } from '@rjsf/utils';

export class DeliveryContainerSettingsFormSchema {
  static Build(showSize = false): RJSFSchema {
    return {
      type: 'object',
      properties: {
        name: {
          type: 'string',
          title: 'Name'
        },
        status: {
          type: 'string',
          title: 'Status',
          default: 'active',
          readOnly: true,
          oneOf: [
            { type: 'string', title: 'Active', enum: ['active'] },
            { type: 'string', title: 'Disabled', enum: ['disabled'] }
          ]
        },
        isConsideredLow: {
          type: 'boolean',
          title: 'Is "Low"',
          default: false,
          oneOf: [
            { const: true, title: 'Yes' },
            { const: false, title: 'No' }
          ]
        },
        ...(showSize && {
          sizeDescription: {
            type: 'string',
            title: 'Size description',
            readOnly: true
          }
        }),
        innerDimensions: {
          type: 'object',
          title: 'Inner Dimensions',
          properties: {
            widthCm: { type: 'number', title: 'Width (cm)', readOnly: true },
            heightCm: { type: 'number', title: 'Height (cm)', readOnly: true },
            depthCm: { type: 'number', title: 'Depth (cm)', readOnly: true }
          }
        },
        outerDimensions: {
          type: 'object',
          title: 'Outer Dimensions',
          properties: {
            widthCm: { type: 'number', title: 'Width (cm)', readOnly: true },
            heightCm: { type: 'number', title: 'Height (cm)', readOnly: true },
            depthCm: { type: 'number', title: 'Depth (cm)', readOnly: true }
          }
        }
      },
      required: ['name']
    };
  }
}
